import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('voice-sms-access-library', {
  library: 'voice-sms-access-library'
});